module.exports = __webpack_public_path__ + "static/media/apply-cover-Tablet.fcf306a7.png";